import { Fleet } from '../interfaces';
import { useCurrentFleet } from '../queries/fleets';

export const useFleet = (): Fleet => {
  const fleet = useCurrentFleet();
  return fleet.data;
};
